let descriptions = [
    {
        'type': 'areas',
        'title': 'Areas',
        'description': 'Visualiza el nivel de estrés de las distintas áreas dentro de tu empresa. Compáralas con otras áreas para ver las dinámicas del estrés'
    },
    {
        'type': 'users',
        'title': 'Usuarios',
        'description': 'Listado de usuarios con sus indicadores más recientes'
    },
    {
        'type': 'stress',
        'title': 'Estrés',
        'description': 'Gráfica para comparar los distintos de estrés dentro de la empresa'
    }
]

export default descriptions;